import { render, staticRenderFns } from "./VehiclesProviderPriceNav.vue?vue&type=template&id=d5d8406e&"
import script from "./VehiclesProviderPriceNav.vue?vue&type=script&lang=js&"
export * from "./VehiclesProviderPriceNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports